import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL ?? 'http://localhost:8081',
    headers: { 'Content-Type': 'application/json' },
});

// Inyecta el Bearer token en cada request
axiosInstance.interceptors.request.use((config) => {
    const raw = localStorage.getItem('auth');
    if (raw) {
        const { token } = JSON.parse(raw);
        if (token) config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
});

// Si el servidor responde 401, limpia la sesión y redirige al login
axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        const isLoginRequest = error.config?.url?.includes('/auth/login');
        if (error.response?.status === 401 && !isLoginRequest) {
            localStorage.removeItem('auth');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
